import { getParentBridgeMode, PARENT_BRIDGE_MODES } from './mode';
import { ModernBridge } from './modern-bridge';
import { LegacyBridge } from './legacy-bridge';
import { setBridgeRef } from './getBridge';

/** Which parent protocol to use for the first-load handshake — set via `build.env.yml` → `vite.config.ts`. */
export const Bridge =
  getParentBridgeMode() === PARENT_BRIDGE_MODES.MODERN_SDK ? new ModernBridge() : new LegacyBridge();

setBridgeRef(Bridge);

export { platform, version } from './common';
export type {
  AllPlatforms,
  ParentEvDataInitRes,
  ParentEvDataOpenRes,
  ParentEvDataLoginRes,
  ParentEvDataVoicePermission,
} from './types';
export { getUrlWithProtocol } from './utilities';
